import React from "react";
import "./NavCurriculum.css";
import { FaChevronDown } from "react-icons/fa";
import smoothscroll from "smoothscroll-polyfill";

function NavCurriculum({ count, setCount, heightTo }) {
  const handleSelectYear = (e) => {
    const targetEl = e.target;
    const yearsEl = document.querySelectorAll(".years");
    const scrollEl = document.querySelector(".safe__area");
    yearsEl.forEach((el) => {
      console.log(targetEl.id);
      console.log(el.id);
      if (el.id === targetEl.id) {
        scrollEl.scrollTo({
          top: heightTo + 100,
          // left: heightTo,
          behavior: "smooth",
          smoothscroll: "smooth",
        });
      }
    });

    // console.log(Number(targetEl.id));
    setCount(Number(targetEl.id));
    //
  };
  return (
    <div className="NavCurriculum activate">
      <div className="navcurriculum__top">
        {count === 0 ? (
          <div onClick={handleSelectYear} id={0} className="years years_active">
            <p id={0} onClick={handleSelectYear}>
              Year 1
            </p>
          </div>
        ) : (
          <div onClick={handleSelectYear} id={0} className="years">
            <p id={0} onClick={handleSelectYear}>
              Year 1
            </p>
          </div>
        )}
        {count === 1 ? (
          <div onClick={handleSelectYear} id={1} className="years years_active">
            <p id={1} onClick={handleSelectYear}>
              Year 2
            </p>
            {/* <FaChevronDown id="selected__year" size={20} /> */}
          </div>
        ) : (
          <div onClick={handleSelectYear} id={1} className="years ">
            <p id={1} onClick={handleSelectYear}>
              Year 2
            </p>
          </div>
        )}
        {count === 2 ? (
          <div onClick={handleSelectYear} id={2} className="years years_active">
            <p id={2} onClick={handleSelectYear}>
              Year 3
            </p>
          </div>
        ) : (
          <div onClick={handleSelectYear} id={2} className="years ">
            <p id={2} onClick={handleSelectYear}>
              Year 3
            </p>
          </div>
        )}
      </div>
      {/* <div className="navcurriculum__bottom">
        <h3>ChildVision1 (CV1)</h3>
        <p>successful Grade 10 applicants</p>
      </div> */}
      {/* <HiMenuAlt2 size={30} />
      <h2 className="nav__text">childVision</h2> */}
    </div>
  );
}

export default NavCurriculum;
